// ═══════════════════════════════════════════════════════════════════════════════
// Portal fixed UI to document.body (avoids iOS PWA inner-scroll fixed positioning bugs)
// ═══════════════════════════════════════════════════════════════════════════════

import { createPortal } from 'react-dom';
import type { ReactNode } from 'react';

export const portalToBody = (node: ReactNode): ReactNode => {
  if (typeof document === 'undefined') {
    return null;
  }
  return createPortal(node, document.body);
};
